import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { parse, subDays, isBefore } from 'date-fns';
import { setPage, setStripeMessage, setPaidToDate, setBalanceDue,
         setBalanceDueDate, setTermsAndConditionsAgreed,
         } from '../../store/AppSlice';
import { getPaymentIntent } from '../../store/AppAPI';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';
import user1 from '../../img/icon/user1.png';
import dog1 from '../../img/icon/dog1.png';
import carCharger from '../../img/icon/charging-station.png';
import calendar from '../../img/icon/calendar.png';
import home from '../../img/icon/home.png';
import time from '../../img/icon/time.png';
import location from '../../img/icon/location.png';
import highchair from '../../img/icon/baby-chair.png';
import crib from '../../img/icon/crib.png';

const ReviewBooking = () => {

  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0,0);
    dispatch(setStripeMessage(null));
  }, []);

  const petPaymentRequired = () => {

    const { bookingDetails } = appstate;

    if (bookingDetails.numberOfPets && bookingDetails.numberOfPets > 0) {
      return (
        <div className="row">
          <div className="col-1">
            <img src={dog1} alt="Pets" width="25" height="25" />
          </div>

          <div className="col-8">
            <div className="generalText">
              <div className="generalTextBox">
              {bookingDetails.numberOfPets} Pet(s):
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="generalText">
              <div className="generalTextBox">
                £{bookingDetails.petPayment}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  const electricCarRequired = () => {

    const { bookingDetails } = appstate;

    if (bookingDetails.electricCar == true) {
      return (<div className="row">
                <div className="col-1">
                  <img src={carCharger} alt="Electric car charging" width="25" height="25" />
                </div>
                <div className="col-8">
                  <div className="generalText">
                    <div className="generalTextBox">
                     Electric Car Charging:
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="generalText">
                    <div className="generalTextBox">
                      £{bookingDetails.carChargingPayment}
                    </div>
                  </div>
                </div>
              </div>
        );
    } else {
      return null;
    }
  }
    

  const highChairRequired = () => {

    const { bookingDetails } = appstate;

    if (bookingDetails.highChairRequired == true) {
      return (
        <div className="row">
          <div className="col-1">
            <img src={highchair} alt="Highchair" width="25" height="25" />
          </div>
          <div className="col-8">
            <div className="generalText">
              <div className="generalTextBox">
                Highchair:
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="generalText">
              <div className="generalTextBox">
                FREE
              </div>
            </div>
          </div>
        </div>
        );
    } else {
      return null;
    }
  }

  const travelCotRequired = () => {

    const { bookingDetails } = appstate;

    if (bookingDetails.cotRequired == true) {
      return (
        <div className="row">
          <div className="col-1">
            <img src={crib} alt="Travel cot" width="25" height="25" />
          </div>
          <div className="col-8">
            <div className="generalText">
              <div className="generalTextBox">
                Travel Cot:
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="generalText">
              <div className="generalTextBox">
                FREE
              </div>
            </div>
          </div>
        </div>
        );
    } else {
      return null;
    }
  }

  const paymentInstructionsText = () => {
    const { bookingDetails } = appstate;
    
    let arrivalDate = parse(bookingDetails.arrivalDate, 'yyyyMMdd', new Date());
    let balanceDueDate = subDays(arrivalDate, 70);
    let isFullAmountDue = false;

    if (isBefore(balanceDueDate, new Date())) {
      isFullAmountDue = true;
    } 

    if (isFullAmountDue) {
      return (
        <div className="row" style={{"marginTop": "1rem"}}>
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                The full amount is due now as it is less than 10 weeks prior to your arrival date.
              </div>
            </div>
          </div>
        </div>
      );

    } else {
      return (
        <div className="row" style={{"marginTop": "1rem"}}>
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                Pay 25% deposit now and the balance 10 weeks prior to your arrival date.  Alternatively
                you can pay the full amount now.
              </div>
            </div>
          </div>
        </div>
      );
    }

  }


  const renderBookingButtons = () => {
    const { bookingDetails } = appstate;
    
    let arrivalDate = parse(bookingDetails.arrivalDate, 'yyyyMMdd', new Date());
    let balanceDueDate = subDays(arrivalDate, 70);
    let isFullAmountDue = false;

    if (isBefore(balanceDueDate, new Date())) {
      isFullAmountDue = true;
    } 

    let depositAndFullAmount = <div className="row booking-row">
                                <div className="col-5 book-deposit" onClick={(e) => { setupDepositPayment() }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <p className="book-btn-text">
                                        <span className="navigate-span">
                                          Book Securely
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12">
                                      <p className="book-btn-text">
                                        <span className="navigate-span">
                                          Deposit <strong>£{bookingDetails.deposit.toFixed(2)}</strong>
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>    
                                <div className="col-2"></div>
                                <div className="col-5 book-deposit" onClick={() => { setupFullPayment() }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <p className="book-btn-text">
                                        <span className="navigate-span">
                                          Book Securely
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12">
                                      <p className="book-btn-text">
                                        <span className="navigate-span">
                                          Full <strong>£{bookingDetails.totalAmount}</strong>
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>  
                              </div>;

let fullAmountOnly = <div className="row booking-row">
                        <div className="col-7"></div>
                        <div className="col-5 book-deposit" onClick={() => { setupFullPayment() }}>
                          <div className="row">
                            <div className="col-12">
                              <p className="book-btn-text">
                                <span className="navigate-span">
                                  Book Securely
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <p className="book-btn-text">
                                <span className="navigate-span">
                                  Full <strong>£{bookingDetails.totalAmount}</strong>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>  
                      </div>;

    if (bookingDetails.termsAndConditionsAgreed == true ) {
      return (
        (isFullAmountDue ? fullAmountOnly : depositAndFullAmount)
      );
      } else {
        return null;
      }
  }

  const createPaymentIntent = (amount) => {
    let request = {
      "item": 
      {"id": "shorecottage-rental",
       "amount": amount*100,
       "description": "Shore Cottage Rental Deposit",
       "paymentIntentId": null
      }
    }

      console.log("Creating payment intent with amount: " + amount);
      dispatch(getPaymentIntent(request));

  }

  const setupDepositPayment = () => {
    const { bookingDetails } = appstate;

    createPaymentIntent(bookingDetails.deposit);

    dispatch(setPaidToDate(bookingDetails.deposit));
    dispatch(setBalanceDue(bookingDetails.totalAmount - bookingDetails.deposit));

    let arrivalDate = parse(bookingDetails.arrivalDate, 'yyyyMMdd', new Date());
    let balanceDueDate = subDays(arrivalDate, 70);

    dispatch(setBalanceDueDate(format(balanceDueDate, "yyyyMMdd")));
    dispatch(setPage("PAYMENT"));
  }
  
  const setupFullPayment = () => {
    const { bookingDetails } = appstate;

    createPaymentIntent(bookingDetails.totalAmount);

    dispatch(setPaidToDate(bookingDetails.totalAmount));
    dispatch(setBalanceDue(0.0));

    dispatch(setPage("PAYMENT"));
  }

  const { bookingDetails } = appstate; 
  let bookingDate = parse(appstate.bookingSelected, 'yyyyMMdd', new Date());
  let selectedDate = format(bookingDate, "EEEE") + " " + format(bookingDate, "do") + " " + format(bookingDate, "MMMM") + " " + format(bookingDate, "y");

  return (
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour">

      
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="keyText">
            <h4 className="availabilityCalendarTextBox">Review Your Booking<span style={{"fontSize": "0.8rem"}}>&nbsp; &nbsp;&nbsp;(Step 3 of 4)</span></h4>
          </div>            
        </div>
      </div>          
      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-1">
          <img src={location} alt="location" width="25" height="25" />
        </div>
        <div className="col-11 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              Shore Cottage, Arnisdale, IV40 8JL
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-1">
          <img src={calendar} alt="Calendar" width="25" height="25" />
        </div>
        <div className="col-11 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              {selectedDate}
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-1">
          <img src={time} alt="Duration" width="25" height="25" />
        </div>
        <div className="col-11 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              {bookingDetails.duration} nights
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-1">
          <img src={user1} alt="User" width="25" height="25" />
        </div>
        <div className="col-11 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              {bookingDetails.numberOfAdults} Adults, {bookingDetails.numberOfChildren} children and {bookingDetails.numberOfInfants} infants 
            </div>
          </div>
        </div>
      </div>

      <hr/>

      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-1">
          <img src={home} alt="Home" width="25" height="25" />
        </div>
        <div className="col-8">
          <div className="generalText">
            <div className="generalTextBox">
              Accomodation cost:
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="generalText">
            <div className="generalTextBox">
              £{bookingDetails.rate}
            </div>
          </div>
        </div>
      </div>

      {petPaymentRequired()}
      {highChairRequired()}
      {travelCotRequired()}
      {electricCarRequired()}

      <hr/>

      <div className="row" style={{"marginTop": "1rem"}}>
        <div className="col-9">
          <div className="generalText">
            <div className="generalTextBox">
              Total cost:
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="generalText">
            <div className="generalTextBox">
              £{bookingDetails.totalAmount}
            </div>
          </div>
        </div>
      </div>

      <hr/>

      {paymentInstructionsText()}

      <div className="row" style={{"marginTop": "0.2rem", "marginBottom": "1rem"}}>
          <div className="col-1">
            <div>
              <input type="checkbox" className="t-and-cs-tick-box" id="confirm-terms-and-conditions" name="confirm-terms-and-conditions" 
                      defaultChecked={bookingDetails.termsAndConditionsAgreed} onChange={(e) => {dispatch(setTermsAndConditionsAgreed(e.target.checked))}}/>
            </div>
          </div>
          <div className="col-11">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="confirm-terms-and-conditions">
                  Click here to confirm that you agree to the <a className="t-and-cs-link"
                    onClick={() => { dispatch(setPage("TERMS_AND_CONDITIONS"))}}>Terms and Conditions</a>
                </label>
              </div>
            </div>
          </div>
        </div>

      {renderBookingButtons()}

      <div className="row">
        <div className="col-6 back-btn-col">
          <p className="back-button">
            <span className="navigate-span">
              <a className="your-details-button" onClick={() => { dispatch(setPage("YOUR_DETAILS"))}}>Back</a>
            </span>
          </p>
        </div>  
      </div>
    </div>
        <div className="col-12 col-md-6 imagesBackgroundColour">
          <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
        </div>
  </div>
  );
}

export default ReviewBooking